import { Paths } from "@/common/paths/paths";

/**
 * Redirects to the session expired page with the current URL as returnTo parameter
 * @param currentPath - The current path that the user was on when permissions expired
 */
export const redirectToSessionExpired = (currentPath?: string): void => {
  const redirect = () => {
    const pathname = window.location?.pathname || "/";
    const search = window.location?.search || "";
    const returnTo = currentPath || pathname + search;
    const sessionExpiredUrl = `${Paths.sessionExpired.url}?returnTo=${encodeURIComponent(returnTo)}`;

    window.location.replace(sessionExpiredUrl);
  };

  if (window.requestIdleCallback) {
    window.requestIdleCallback(redirect, { timeout: 100 });
  } else {
    // Fallback for browsers without requestIdleCallback
    setTimeout(redirect, 0);
  }
};

/**
 * Handles session/permission expiration by redirecting to the session expired page
 * This function can be called from API error handlers when permissions expire
 */
export const handleSessionExpiration = (): void => {
  redirectToSessionExpired();
};
